export enum PlatformName {
  LinkedIn = 'LINKED_IN',
  Facebook = 'FACEBOOK',
  Twitter = 'TWITTER',
  Instagram = 'INSTAGRAM',
  Tiktok = 'TIKTOK',
  Youtube = 'YOUTUBE',
}

export enum SocialPostType {
  Share = 'SHARE',
  Template = 'TEMPLATE',
}

export enum AttachmentType {
  Image = 'IMAGE',
  Video = 'VIDEO',
  Url = 'URL',
  Pdf = 'PDF',
}

export enum TemplateStatus {
  Draft = 'DRAFT',
  Posted = 'POSTED',
}

export interface SharedPost {
  platform: PlatformName;
  platform_post_id: string;
  platform_post_permalink: string;
}

export interface Hashtag {
  id: string;
  name: string;
  usage_count: number;
}

export interface SocialHashtag {
  id: string;
  display_tag: string;
  hashtag: Hashtag;
}

export interface Attachment {
  id: string;
  url: string;
  type: AttachmentType;
  thumbnail_url?: string;
  title?: string;
  mime_type?: string;
  size_bytes?: number;
}

export interface AttachmentShortUrl {
  short_url: {
    short_url: string;
  };
}

export interface SocialPostAttachment {
  id: string;
  sort_order: number;
  attachment: Attachment;
  social_post_attachment_short_url?: AttachmentShortUrl | null;
}

export interface SocialPostCopy {
  id: string;
  content: string;
}

export interface SocialPostInvite {
  id: string;
  start_at: string | null;
  end_at: string | null;
  edit_fields: Record<string, boolean> | null;
}

export interface SocialPostMention {
  start_index: number;
  end_index: number;
  social_profile_id?: string;
  display_name?: string;
}

export interface AmplifiedPostDetail {
  id: string;
  scheduled_at?: string | null;
  title: string;
  post_type: SocialPostType;
  template_cta?: string;
  template_status: TemplateStatus;
  social_post_hashtags: SocialHashtag[];
  social_post_attachments: SocialPostAttachment[];
  social_post_copies: SocialPostCopy[];
  social_post_invite: SocialPostInvite | null;
  social_post_mentions?: SocialPostMention[];
}
